import React, { useState, useEffect } from 'react';
import {
    Button, Card, CardHeader, Table, Container, Row, Col, Form, FormGroup, InputGroupAddon, InputGroupText, Input, InputGroup, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal, ModalHeader, ModalBody, Badge, Label,
    UncontrolledTooltip, UncontrolledDropdown, ModalFooter,
} from "reactstrap";
import { Link } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Header from "dashboard/project-management/components/Headers/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import Webcam from "react-webcam";
import { Logger } from 'sass';
import { api } from '../../../../api';
import Cookies from 'js-cookie';
import * as XLSX from 'xlsx';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';


const Labour = () => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [projectDropdownOpen, setProjectDropdownOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [modal, setModal] = useState(false); // State to control modal visibility
    const [modalAdd, setModalAdd] = useState(false);
    const [modalEdit, setModalEdit] = useState(false); // Add edit modal state
    const toggleModalAdd = () => setModalAdd(prevState => !prevState);
    const toggleModalEdit = () => setModalEdit(prevState => !prevState);
    const [clientForm, setClientForm] = useState({})
    const [image, setImage] = useState(null);
    const [profileImage, setProfileImage] = useState(null);
    const [editProfileImage, setEditProfileImage] = useState(null); // Add edit profile image state

    const emp_id = Cookies.get('token');

  // Generate years from current year to 10 years ago
  const imageStyle = {
    height: '30px',
    width: '30px',
    borderRadius: '50%',
    transition: 'transform 0.3s ease',
};

const imageHoverStyle = {
    ...imageStyle,
    transform: 'scale(1.5)',
};
    const [dropdownOpen2, setDropdownOpen2] = useState(false);
    const toggleDropdown2 = () => setDropdownOpen2((prevState) => !prevState);
    const [selectedProject, setSelectedProject] = useState("");

    // Edit state management
    const [editLabourData, setEditLabourData] = useState({
        l_id: '',
        emp_id: emp_id,
        name: '',
        number: '',
        p_id: '',
        image: ''
    });

    // Success alert for editing labour
    const [showEditSuccessAlert, setShowEditSuccessAlert] = useState(false);
    const [editSuccessMessage, setEditSuccessMessage] = useState("");

    // Edit form validation states
    const [editValidationErrors, setEditValidationErrors] = useState({});
    const [isEditSubmitting, setIsEditSubmitting] = useState(false);

    const [project, setproject] = useState([]);
    const fetchProjectData = async () => {
    try {
        const company_id = Cookies.get('company_id');
        const response = await api.get(`viewProjectDetails.php?s_m_id=${emp_id}&company_id=${company_id}`);
        setproject(response.data);
        console.log(response.data);
    } catch (error) {
        console.error("Error fetching data:", error);
    }
    };

  const [selectedDate, setSelectedDate] = useState(new Date());

  useEffect(() => {
    let originalData = []; // use let instead of const

    const fetchData = async () => {
        try {
            const company_id = Cookies.get('company_id');
            const dateStr = selectedDate.toISOString().split('T')[0];
            const response = await api.get(`addLabour.php?emp_id=${emp_id}&company_id=${company_id}&date=${dateStr}`);
            console.log(response.data); // Log the response data

            // Ensure originalData is an array
            if (Array.isArray(response.data)) {
                originalData = response.data;
            } else {
                console.error("Error: response data is not an array");
                return;
            }

            // Filter data after fetching
            const filtered = originalData.filter(item =>
                item.l_name.toLowerCase().includes(searchQuery.toLowerCase())
            );
            setFilteredData(filtered);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    fetchData();
    fetchProjectData();
}, [searchQuery, selectedDate]);

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const toggleProjectDropdown = () => {
        setProjectDropdownOpen(!projectDropdownOpen);
    };

    const toggleModal = () => {
        setModal(!modal);
    };

    // Function to open edit modal and populate data
    const handleEditLabour = (labour) => {
        setEditLabourData({
            l_id: labour.l_id,
            emp_id: emp_id,
            name: labour.l_name,
            number: labour.l_number,
            p_id: labour.p_id,
            image: labour.profile_image || ''
        });
        setEditProfileImage(labour.profile_image ? getImagePath(labour.profile_image) : null);
        setModalEdit(true);
    };

    // Edit form validation function
    const validateEditForm = () => {
        const errors = {};
        
        // Validate project selection
        if (!editLabourData.p_id || editLabourData.p_id.trim() === '') {
            errors.p_id = 'Please select a project';
        }
        
        // Validate labour name
        if (!editLabourData.name || editLabourData.name.trim() === '') {
            errors.name = 'Labour name is required';
        } else if (editLabourData.name.trim().length < 2) {
            errors.name = 'Labour name must be at least 2 characters';
        }
        
        // Validate mobile number
        if (!editLabourData.number || editLabourData.number.trim() === '') {
            errors.number = 'Mobile number is required';
        } else if (!/^[0-9]{10}$/.test(editLabourData.number.trim())) {
            errors.number = 'Please enter a valid 10-digit mobile number';
        }
        
        // Validate image (optional but if provided, should be valid)
        if (editLabourData.image && editLabourData.image instanceof File) {
            const maxSize = 5 * 1024 * 1024; // 5MB
            if (editLabourData.image.size > maxSize) {
                errors.image = 'Image size should not exceed 5MB';
            }
            
            const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
            if (!allowedTypes.includes(editLabourData.image.type)) {
                errors.image = 'Please upload a valid image file (JPEG, PNG, or GIF)';
            }
        }
        
        return errors;
    };

    // Function to handle edit form submission
    const handleEditFormSubmit = async (e) => {
        e.preventDefault();
        
        // Clear previous validation errors
        setEditValidationErrors({});
        
        // Validate form
        const errors = validateEditForm();
        if (Object.keys(errors).length > 0) {
            setEditValidationErrors(errors);
            return;
        }
        
        setIsEditSubmitting(true);

        const formDataToSend = new FormData();
        formDataToSend.append("l_id", editLabourData.l_id);
        formDataToSend.append("emp_id", emp_id);
        formDataToSend.append("p_id", editLabourData.p_id);
        formDataToSend.append("name", editLabourData.name.trim());
        formDataToSend.append("number", editLabourData.number.trim());
        if (editLabourData.image instanceof File) {
            formDataToSend.append("image", editLabourData.image);
        }
        formDataToSend.append("company_id", Cookies.get('company_id'));

        try {
            const response = await api.post('editLabour.php', formDataToSend);
            console.log("Edit data sent successfully:", response.data);
            if(response.data.message === "Exists"){
                setEditValidationErrors({ number: 'User with this number already exists' });
            } else {
                setEditSuccessMessage("Labour updated successfully!");
                setShowEditSuccessAlert(true);
                setModalEdit(false);
            }
        } catch (error) {
            console.error("Error updating data:", error);
            setEditValidationErrors({ general: 'Failed to update labour. Please try again.' });
        } finally {
            setIsEditSubmitting(false);
        }
    };

    // Function to handle edit input changes
    const handleEditInputChange = (e) => {
        const { name, value } = e.target;
        setEditLabourData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    // Function to handle edit file upload
    const handleEditFileUpload = (event) => {
        const file = event.target.files[0];
        setEditProfileImage(URL.createObjectURL(file));
        setEditLabourData(prevState => ({
            ...prevState,
            image: file
        }));
    };

    const [labourData, setlabourData] = useState({
        emp_id : emp_id,
        name : '',
        number : '',
        p_id : '',
        image : ''
    });

    // Success alert for adding labour
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    // Success alert for deleting labour
    const [showDeleteSuccessAlert, setShowDeleteSuccessAlert] = useState(false);
    const [deleteSuccessMessage, setDeleteSuccessMessage] = useState("");

    // Form validation states
    const [validationErrors, setValidationErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Validation function
    const validateForm = () => {
        const errors = {};
        
        // Validate project selection
        if (!labourData.p_id || labourData.p_id.trim() === '') {
            errors.p_id = 'Please select a project';
        }
        
        // Validate labour name
        if (!labourData.name || labourData.name.trim() === '') {
            errors.name = 'Labour name is required';
        } else if (labourData.name.trim().length < 2) {
            errors.name = 'Labour name must be at least 2 characters';
        }
        
        // Validate mobile number
        if (!labourData.number || labourData.number.trim() === '') {
            errors.number = 'Mobile number is required';
        } else if (!/^[0-9]{10}$/.test(labourData.number.trim())) {
            errors.number = 'Please enter a valid 10-digit mobile number';
        }
        
        // Validate image (optional but if provided, should be valid)
        if (labourData.image && labourData.image instanceof File) {
            const maxSize = 5 * 1024 * 1024; // 5MB
            if (labourData.image.size > maxSize) {
                errors.image = 'Image size should not exceed 5MB';
            }
            
            const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
            if (!allowedTypes.includes(labourData.image.type)) {
                errors.image = 'Please upload a valid image file (JPEG, PNG, or GIF)';
            }
        }
        
        return errors;
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        
        // Clear previous validation errors
        setValidationErrors({});
        
        // Validate form
        const errors = validateForm();
        if (Object.keys(errors).length > 0) {
            setValidationErrors(errors);
            return;
        }
        
        setIsSubmitting(true);

        const formDataToSend = new FormData();
        formDataToSend.append("emp_id", emp_id);
        formDataToSend.append("p_id", labourData.p_id);
        formDataToSend.append("name", labourData.name.trim());
        formDataToSend.append("number", labourData.number.trim());
        formDataToSend.append("image", labourData.image);
        formDataToSend.append("company_id", Cookies.get('company_id'));

        try {
            const response = await api.post('addLabour.php', formDataToSend);
            console.log("Data sent successfully:", response.data);
            if(response.data.message === "Exists"){
                setValidationErrors({ number: 'User with this number already exists' });
            }else{
                setSuccessMessage("Labour added successfully!");
                setShowSuccessAlert(true);
                // Reset form
                setlabourData({
                    emp_id: emp_id,
                    name: '',
                    number: '',
                    p_id: '',
                    image: ''
                });
                setProfileImage(null);
                setModalAdd(false);
            }
        } catch (error) {
            console.error("Error submitting data:", error);
            setValidationErrors({ general: 'Failed to add labour. Please try again.' });
        } finally {
            setIsSubmitting(false);
        }
    };

    
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setlabourData(prevState => ({
            ...prevState,
            [name]: value
        }));
        console.log(labourData);
    };





    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        setProfileImage(URL.createObjectURL(file));
        setlabourData(prevState => ({
            ...prevState,
            image : file
        }));
        console.log(labourData);
    };
   
    
    const handleProjectSelect = async (project) => {
        if (project === 'ALL_PROJECTS') {
            // Fetch all labour for the company
            try {
                const company_id = Cookies.get('company_id');
                const dateStr = selectedDate.toISOString().split('T')[0];
                const response = await api.get(`addLabour.php?company_id=${company_id}&date=${dateStr}`);
                if (Array.isArray(response.data)) {
                    setFilteredData(response.data);
                } else if (response.data && response.data.message) {
                    setFilteredData([]);
                } else {
                    setFilteredData([]);
                }
                setSelectedProject('');
            } catch (error) {
                setFilteredData([]);
            }
        } else {
            setSelectedProject(project.p_name);
            try {
                const company_id = Cookies.get('company_id');
                const response = await api.get(`addLabour.php?p_id=${project.p_id}&emp_id=${emp_id}&company_id=${company_id}`);
                if (Array.isArray(response.data)) {
                    setFilteredData(response.data);
                } else if (response.data && response.data.message) {
                    setFilteredData([]);
                } else {
                    setFilteredData([]);
                }
            } catch (error) {
                setFilteredData([]);
            }
        }
    };
    
    

    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [labourIdToDelete, setLabourIdToDelete] = useState(null);

    const deleteLabour = async () => {
        try {
          const company_id = Cookies.get('company_id');
          const response = await api.get(`addLabour.php?l_id=${labourIdToDelete}&company_id=${company_id}`);
          console.log(response.data);
          setFilteredData((prevTasks) => prevTasks.filter((tasks) => tasks.l_id !== labourIdToDelete));
          setDeleteSuccessMessage("Labour deleted successfully!");
          setShowDeleteSuccessAlert(true);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
        setLabourIdToDelete(null);
        setShowDeleteConfirmation(false);
    };
    
    const handleLabourAttandances = (lab_id) => {
        const fetchData = async () => {
            const data = {
                l_id : lab_id,
                company_id: Cookies.get('company_id'),
                date: selectedDate.toISOString().split('T')[0]
            }
            try {
              const response = await api.post('labourAttendances.php', data);
              console.log(response.data);
              setFilteredData(prevTasks => {
                return prevTasks.map(task => {
                    if (task.l_id === lab_id) {
                        task.attendances = "present";
                    }
                    return task;
                });
              });
            } catch (error) {
              console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }

    const getImagePath = (imageName) => {
        const defaultImage = '/images/default-profile.png'; // Use this for both localhost and production

        if (!imageName || imageName === 'default-profile.png') return defaultImage;

        const isProduction = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';
        return isProduction ? `/images/${imageName}` : `/images/${imageName}`;
    };

    // Export to Excel function
    const handleExportExcel = () => {
        const exportData = filteredData.map(item => ({
            'Labour ID': item.l_id,
            'Name': item.l_name,
            'Number': item.l_number,
            'Attendance': item.attendances,
            'Project': item.p_id,
            'Date': selectedDate.toISOString().split('T')[0]
        }));
        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Attendance");
        XLSX.writeFile(wb, `attendance_${selectedDate.toISOString().split('T')[0]}.xlsx`);
    };

    return (
        <>
            <div className="header bg-gradient-info py-7 py-lg-8">
                <Container fluid>
                     <Row className="mb-5">
  {/* Heading - Always First */}
  <Col xs="12" md="4"  className="order-1 order-md-1 mb-3 mb-md-0 d-flex justify-content-center justify-content-md-start align-items-center">
    <h1 className='font-bold'>Labour Details</h1>
  </Col>

  {/* Search - Third on mobile, second on desktop */}
  <Col xs="12" md="4" className="order-3 order-md-2 d-flex justify-content-md-end justify-content-start mb-3 mb-md-0">
    <Form className="navbar-search px-2 w-full max-w-[300px]">
  <FormGroup className="mb-0 w-full">
    <InputGroup className="input-group-alternative align-items-center h-[40px]">
      <InputGroupAddon addonType="prepend">
        <InputGroupText className="border-r-0 h-[38px]">
          <i
            className="fas fa-search text-black 
                       block md:hidden lg:block"
          />
          <Input
            placeholder="Search Labour Name"
            type="text"
            className="border-l-0 ml-2 h-[38px]"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </InputGroupText>
      </InputGroupAddon>
    </InputGroup>
  </FormGroup>
</Form>

  </Col>

  {/* Dropdown - Second on mobile, third on desktop */}
  <Col xs="12" md="4" className="order-2 order-md-3 d-flex justify-content-md-end justify-content-start">
    <Dropdown isOpen={dropdownOpen2} toggle={toggleDropdown2}>
      <DropdownToggle caret>
        {selectedProject ? selectedProject : "All Projects"}
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem onClick={() => handleProjectSelect('ALL_PROJECTS')}>All Projects</DropdownItem>
        {Array.isArray(project) ? (
          project.map((projectItem, index) => (
            <DropdownItem
              key={index}
              onClick={() => handleProjectSelect(projectItem)}
            >
              {projectItem.p_name}
            </DropdownItem>
          ))
        ) : (
          <p>No projects available</p>
        )}
      </DropdownMenu>
    </Dropdown>
  </Col>
</Row>

<Row className="mt-5">
  <Col className="mb-5 mb-xl-0" xl="12">
    <Card style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)', backgroundColor: '#fff', borderRadius: '15px' }}>
      <CardHeader className="border-0">
        {/* Header */}
        <h3 className="mb-3 text-center text-xl-left">Attendance List</h3>

        {/* Responsive container */}
        <div className="d-flex flex-column flex-md-column flex-lg-row align-items-center align-items-lg-center justify-content-lg-end gap-2">
          {/* Date picker */}
          <div className="d-flex align-items-center mb-2 mb-md-2 mb-lg-0 gap-2">
  <label htmlFor="attendance-date" style={{ fontWeight: 400, marginBottom: 0 }}>Select Date:</label>
  <input
    id="attendance-date"
    type="date"
    value={selectedDate.toISOString().split('T')[0]}
    max={new Date().toISOString().split('T')[0]}
    onChange={e => setSelectedDate(new Date(e.target.value))}
    style={{ padding: '0.25rem 0.5rem', borderRadius: '4px', border: '1px solid #ccc' }}
  />
</div>


          {/* Mobile view: buttons stacked; tablet view: buttons side by side; laptop: inline */}
          <div className="d-flex flex-column flex-md-row flex-lg-row gap-2 mt-2 mt-md-2 mt-lg-0">
            <Button
              style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black' }}
              onClick={handleExportExcel}
            >
              Export Excel
            </Button>
            <Button
              style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black' }}
              onClick={toggleModalAdd}
            >
              Add New Labour
            </Button>
          </div>
        </div>
      </CardHeader>

      <Table className="align-items-center table-flush" responsive>
        <thead className="thead-light">
          <tr>
            <th scope="col">Labour ID</th>
            <th scope="col">Profile</th>
            <th scope="col">Name</th>
            <th scope="col">Number</th>
            <th scope="col">Attendance</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(filteredData) && filteredData.length > 0 ? (
            filteredData.map((item, index) => (
              <tr key={index}>
                <td>{item.l_id}</td>
                <td>
                  <img
                    alt="...Image Not Found"
                    className="rounded-circle"
                    src={item.profile_image ? getImagePath(item.profile_image) : getImagePath('default-profile.png')}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = getImagePath('default-profile.png');
                    }}
                    style={{ width: '50px', height: '50px' }}
                  />
                </td>
                <td>{item.l_name}</td>
                <td>{item.l_number}</td>
                <td>
                  <Badge color={item.attendances === "present" ? 'success' : 'danger'}>
                    {item.attendances}
                  </Badge>
                </td>
                <td>
                  <a href="#pablo" className='mr-3'>
                    <span id={`delete-tooltip-${item.l_id}`}>
                      <i className='fa fa-trash' onClick={() => {
                        setLabourIdToDelete(item.l_id);
                        setShowDeleteConfirmation(true);
                      }}></i>
                    </span>
                    <UncontrolledTooltip delay={0} target={`delete-tooltip-${item.l_id}`}>
                      Delete Labour
                    </UncontrolledTooltip>
                  </a>
                  {item.attendances !== "present" && (
                    <button
                      onClick={() => handleLabourAttandances(item.l_id)}
                      className="badge btn btn-danger text-center pl-3"
                      type='submit'
                    >
                      <Tippy content="Mark as Present">
                        <i className='fas fa-user-check'></i>
                      </Tippy>
                    </button>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6">No data available</td>
            </tr>
          )}
        </tbody>
      </Table>
    </Card>
  </Col>
</Row>

                </Container>
            </div>

            <Modal isOpen={modalAdd} toggle={toggleModalAdd}>
                <ModalHeader toggle={toggleModalAdd}>Add Labour</ModalHeader>
                <Form onSubmit={handleFormSubmit}>
                    <Row className="justify-content-center align-items-center">
                        <Col lg="12" className="text-center mb-3">
                            {/* Displaying a placeholder image if profileImage is null */}
                            {!profileImage && (
                            <div
                                className="profile-image-container"
                                style={{
                                width: '120px',
                                height: '120px',
                                border: '2px solid black',
                                borderRadius: '50%',
                                overflow: 'hidden',
                                boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
                                margin: '0 auto',
                                }}
                            >
                                <img
                                src={require("../../assets/img/brand/AECP.logo.png")}
                                alt="Placeholder"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                }}
                                />
                            </div>
                            )}
                            {/* Displaying the uploaded image */}
                            {profileImage && (
                            <div
                                className="profile-image-container"
                                style={{
                                width: '120px',
                                height: '120px',
                                border: '2px solid black',
                                borderRadius: '50%',
                                overflow: 'hidden',
                                boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
                                margin: '0 auto',
                                }}
                            >
                                <img
                                src={profileImage}
                                alt="Profile"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                }}
                                />
                            </div>
                            )}
                        </Col>

                        <Col lg="12" className="text-center">
                            <Button
                              style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'white' }}
                              onClick={() => document.getElementById('input-profile-image').click()}
                            >
                              <FontAwesomeIcon icon={faPencilAlt} /> Labour Image
                            </Button>
                            <FormGroup style={{ display: 'none' }}>
                            <Input
                                type="file"
                                id="input-profile-image"
                                accept="image/*"
                                onChange={handleFileUpload}
                                
                            />
                            </FormGroup>
                        </Col>
                        </Row>
                    <Row className='px-3'>
                    <Col md={12}>
                              <FormGroup>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-project"
                                >
                                  Project Name <span style={{color: 'red'}}>*</span>
                                </label>
                                <Input
                                  className={`form-control-alternative ${validationErrors.p_id ? 'is-invalid' : ''}`}
                                  id="input-project"
                                  type="select"
                                  name="p_id"
                                  value={labourData.p_id}
                                  onChange={handleInputChange}
                                  required
                                >
                                  <option value="">Select Project</option>
                                  {project &&
                                    Array.isArray(project) &&
                                    project.map((option) => (
                                      <option
                                        key={option.p_id}
                                        value={option.p_id}
                                      >
                                        {option.p_name}
                                      </option>
                                    ))}
                                </Input>
                                {validationErrors.p_id && (
                                  <div className="invalid-feedback d-block" style={{color: 'red', fontSize: '0.875rem'}}>
                                    {validationErrors.p_id}
                                  </div>
                                )}
                              </FormGroup>
                            </Col>

                        <Col md={12}>
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-name">Labour Name <span style={{color: 'red'}}>*</span></label>
                                <Input
                                    className={`form-control-alternative ${validationErrors.name ? 'is-invalid' : ''}`}
                                    id="input-name"
                                    type="text"
                                    name="name"
                                    value={labourData.name}
                                    onChange={handleInputChange}
                                    placeholder='Enter labour name'
                                    required
                                />
                                {validationErrors.name && (
                                  <div className="invalid-feedback d-block" style={{color: 'red', fontSize: '0.875rem'}}>
                                    {validationErrors.name}
                                  </div>
                                )}
                            </FormGroup>
                        </Col>
                        <Col md={12}>
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-number">Mobile Number <span style={{color: 'red'}}>*</span></label>
                                <Input
                                    className={`form-control-alternative ${validationErrors.number ? 'is-invalid' : ''}`}
                                    id="input-number"
                                    type="text"
                                    name="number"
                                    value={labourData.number}
                                    onChange={handleInputChange}
                                    placeholder='Enter 10-digit mobile number'
                                    maxLength="10"
                                    required
                                />
                                {validationErrors.number && (
                                  <div className="invalid-feedback d-block" style={{color: 'red', fontSize: '0.875rem'}}>
                                    {validationErrors.number}
                                  </div>
                                )}
                            </FormGroup>
                        </Col>

                        {validationErrors.image && (
                          <Col md={12}>
                            <div className="text-danger" style={{fontSize: '0.875rem'}}>
                              {validationErrors.image}
                            </div>
                          </Col>
                        )}

                        {validationErrors.general && (
                          <Col md={12}>
                            <div className="text-danger" style={{fontSize: '0.875rem'}}>
                              {validationErrors.general}
                            </div>
                          </Col>
                        )}

                    </Row>
                    <Row>
                        <Col lg='12' className='text-center mb-2'>
                            <Button 
                                style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}} 
                                type="submit"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? (
                                    <>
                                        <i className="fas fa-spinner fa-spin mr-2"></i>
                                        Adding Labour...
                                    </>
                                ) : (
                                    'Submit'
                                )}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Modal>

            {/* Success Alert Modal for Adding Labour */}
            {showSuccessAlert && (
              <div style={{
                position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
                justifyContent: 'center', alignItems: 'flex-start', paddingTop: '15%', zIndex: 9999
              }}>
                <div style={{
                  backgroundColor: '#fff', padding: '30px', borderRadius: '15px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.3)', textAlign: 'center',
                  maxWidth: '400px', width: '90%', border: '3px solid #d86f89'
                }}>
                  <div style={{ fontSize: '48px', color: '#d86f89', marginBottom: '20px' }}>✓</div>
                  <h4 style={{ color: '#28a745', marginBottom: '15px' }}>Success!</h4>
                  <p style={{ color: '#333', fontSize: '16px', marginBottom: '20px' }}>{successMessage}</p>
                  <Button
                    style={{
                      backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'white',
                      padding: '10px 25px', borderRadius: '25px'
                    }}
                    onClick={() => { setShowSuccessAlert(false); window.location.reload(); }}
                  >OK</Button>
                </div>
              </div>
            )}

            {/* Success Alert Modal for Deleting Labour */}
            {showDeleteSuccessAlert && (
              <div style={{
                position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
                justifyContent: 'center', alignItems: 'flex-start', paddingTop: '15%', zIndex: 9999
              }}>
                <div style={{
                  backgroundColor: '#fff', padding: '30px', borderRadius: '15px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.3)', textAlign: 'center',
                  maxWidth: '400px', width: '90%', border: '3px solid #d86f89'
                }}>
                  <div style={{ fontSize: '48px', color: '#d86f89', marginBottom: '20px' }}>✓</div>
                  <h4 style={{ color: '#28a745', marginBottom: '15px' }}>Success!</h4>
                  <p style={{ color: '#333', fontSize: '16px', marginBottom: '20px' }}>{deleteSuccessMessage}</p>
                  <Button
                    style={{
                      backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'white',
                      padding: '10px 25px', borderRadius: '25px'
                    }}
                    onClick={() => { setShowDeleteSuccessAlert(false); window.location.reload(); }}
                  >OK</Button>
                </div>
              </div>
            )}

            <Modal isOpen={modalEdit} toggle={toggleModalEdit}>
                <ModalHeader toggle={toggleModalEdit}>Edit Labour</ModalHeader>
                <Form onSubmit={handleEditFormSubmit}>
                    <Row className="justify-content-center align-items-center">
                        <Col lg="12" className="text-center mb-3">
                            {/* Displaying a placeholder image if editProfileImage is null */}
                            {!editProfileImage && (
                            <div
                                className="profile-image-container"
                                style={{
                                width: '120px',
                                height: '120px',
                                border: '2px solid black',
                                borderRadius: '50%',
                                overflow: 'hidden',
                                boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
                                margin: '0 auto',
                                }}
                            >
                                <img
                                src={require("../../assets/img/brand/AECP.logo.png")}
                                alt="Placeholder"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                }}
                                />
                            </div>
                            )}
                            {/* Displaying the uploaded image */}
                            {editProfileImage && (
                            <div
                                className="profile-image-container"
                                style={{
                                width: '120px',
                                height: '120px',
                                border: '2px solid black',
                                borderRadius: '50%',
                                overflow: 'hidden',
                                boxShadow: '0 0 10px rgba(0, 0, 0, 0.5)',
                                margin: '0 auto',
                                }}
                            >
                                <img
                                src={editProfileImage}
                                alt="Profile"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                }}
                                />
                            </div>
                            )}
                        </Col>

                        <Col lg="12" className="text-center">
                            <Button
                              style={{ backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'white' }}
                              onClick={() => document.getElementById('input-edit-profile-image').click()}
                            >
                              <FontAwesomeIcon icon={faPencilAlt} /> Labour Image
                            </Button>
                            <FormGroup style={{ display: 'none' }}>
                            <Input
                                type="file"
                                id="input-edit-profile-image"
                                accept="image/*"
                                onChange={handleEditFileUpload}
                            />
                            </FormGroup>
                        </Col>
                        </Row>
                    <Row className='px-3'>
                    <Col md={12}>
                              <FormGroup>
                                <label
                                  className="form-control-label"
                                  htmlFor="input-edit-project"
                                >
                                  Project Name <span style={{color: 'red'}}>*</span>
                                </label>
                                <Input
                                  className={`form-control-alternative ${editValidationErrors.p_id ? 'is-invalid' : ''}`}
                                  id="input-edit-project"
                                  type="select"
                                  name="p_id"
                                  onChange={handleEditInputChange}
                                  value={editLabourData.p_id}
                                  required
                                >
                                  <option value="">Select Project</option>
                                  {project &&
                                    Array.isArray(project) &&
                                    project.map((option) => (
                                      <option
                                        key={option.p_id}
                                        value={option.p_id}
                                      >
                                        {option.p_name}
                                      </option>
                                    ))}
                                </Input>
                                {editValidationErrors.p_id && (
                                  <div className="invalid-feedback d-block" style={{color: 'red', fontSize: '0.875rem'}}>
                                    {editValidationErrors.p_id}
                                  </div>
                                )}
                              </FormGroup>
                            </Col>

                        <Col md={12}>
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-edit-name">Labour Name <span style={{color: 'red'}}>*</span></label>
                                <Input
                                    className={`form-control-alternative ${editValidationErrors.name ? 'is-invalid' : ''}`}
                                    id="input-edit-name"
                                    type="text"
                                    name="name"
                                    onChange={handleEditInputChange}
                                    value={editLabourData.name}
                                    placeholder='Enter labour name'
                                    required
                                />
                                {editValidationErrors.name && (
                                  <div className="invalid-feedback d-block" style={{color: 'red', fontSize: '0.875rem'}}>
                                    {editValidationErrors.name}
                                  </div>
                                )}
                            </FormGroup>
                        </Col>
                        <Col md={12}>
                            <FormGroup>
                                <label className="form-control-label" htmlFor="input-edit-number">Mobile Number <span style={{color: 'red'}}>*</span></label>
                                <Input
                                    className={`form-control-alternative ${editValidationErrors.number ? 'is-invalid' : ''}`}
                                    id="input-edit-number"
                                    type="text"
                                    name="number"
                                    onChange={handleEditInputChange}
                                    value={editLabourData.number}
                                    placeholder='Enter 10-digit mobile number'
                                    maxLength="10"
                                    required
                                />
                                {editValidationErrors.number && (
                                  <div className="invalid-feedback d-block" style={{color: 'red', fontSize: '0.875rem'}}>
                                    {editValidationErrors.number}
                                  </div>
                                )}
                            </FormGroup>
                        </Col>

                        {editValidationErrors.image && (
                          <Col md={12}>
                            <div className="text-danger" style={{fontSize: '0.875rem'}}>
                              {editValidationErrors.image}
                            </div>
                          </Col>
                        )}

                        {editValidationErrors.general && (
                          <Col md={12}>
                            <div className="text-danger" style={{fontSize: '0.875rem'}}>
                              {editValidationErrors.general}
                            </div>
                          </Col>
                        )}

                    </Row>
                    <Row>
                        <Col lg='12' className='text-center mb-2'>
                            <Button 
                                style={{backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'black'}} 
                                type="submit"
                                disabled={isEditSubmitting}
                            >
                                {isEditSubmitting ? (
                                    <>
                                        <i className="fas fa-spinner fa-spin mr-2"></i>
                                        Updating Labour...
                                    </>
                                ) : (
                                    'Submit'
                                )}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Modal>

            {/* Success Alert Modal for Editing Labour */}
            {showEditSuccessAlert && (
              <div style={{
                position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
                justifyContent: 'center', alignItems: 'flex-start', paddingTop: '15%', zIndex: 9999
              }}>
                <div style={{
                  backgroundColor: '#fff', padding: '30px', borderRadius: '15px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.3)', textAlign: 'center',
                  maxWidth: '400px', width: '90%', border: '3px solid #d86f89'
                }}>
                  <div style={{ fontSize: '48px', color: '#d86f89', marginBottom: '20px' }}>✓</div>
                  <h4 style={{ color: '#28a745', marginBottom: '15px' }}>Success!</h4>
                  <p style={{ color: '#333', fontSize: '16px', marginBottom: '20px' }}>{editSuccessMessage}</p>
                  <Button
                    style={{
                      backgroundColor: '#d86f89', borderColor: '#d86f89', color: 'white',
                      padding: '10px 25px', borderRadius: '25px'
                    }}
                    onClick={() => { setShowEditSuccessAlert(false); window.location.reload(); }}
                  >OK</Button>
                </div>
              </div>
            )}

            <Modal isOpen={showDeleteConfirmation} toggle={() => setShowDeleteConfirmation(false)}>
              <ModalHeader>Confirm Deletion</ModalHeader>
              <ModalBody>
                Are you sure you want to delete this labour?
              </ModalBody>
              <ModalFooter>
                <Button color="danger" onClick={deleteLabour}>Yes</Button>
                <Button color="secondary" onClick={() => setShowDeleteConfirmation(false)}>No</Button>
              </ModalFooter>
            </Modal>

        </>
    );
};

export default Labour;